import { useEffect, useState } from "react";
import { Box, IconButton, TableCell, TextField } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

interface EditableCellProps {
  churchId: string;
  rowSpan: number;
  value: number;
  isEditing: boolean;
  onStartEdit: () => void;
  onSave: (value: number) => void;
  onCancel: () => void;
}

const EditableCell = ({
  churchId,
  rowSpan,
  value,
  isEditing,
  onStartEdit,
  onSave,
  onCancel,
}: EditableCellProps) => {
  const [localValue, setLocalValue] = useState(String(value));

  useEffect(() => {
    setLocalValue(String(value));
  }, [value, isEditing, setLocalValue]);

  return (
    <TableCell key={churchId} rowSpan={rowSpan} width={"5rem"}>
      {isEditing ? (
        <Box display="flex">
          <TextField
            type="number"
            size="small"
            sx={{ maxWidth: "10ch" }}
            variant="outlined"
            value={localValue}
            onChange={(e) => setLocalValue(e.target.value)}
            onBlur={() => {
              const parsed = parseInt(localValue, 10);
              if (isNaN(parsed)) {
                setLocalValue(String(value));
              }
            }}
          />
          <IconButton
            size="small"
            onClick={() => onSave(parseInt(localValue, 10))}
            aria-label="Save"
          >
            <CheckIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={onCancel} aria-label="Cancel">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      ) : (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <span>{value}</span>
          <IconButton size="small" onClick={onStartEdit}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </TableCell>
  );
};

export default EditableCell;
